<template>
    <b-container class='page-container'>
        <b-card class='title-card'>
            <b-row v-if='!profile'>
                <b-col>
                    <h1>/r/CFB Book</h1>
                </b-col>
            </b-row>
            <b-row v-if='!profile'>
                <b-col>
                    <img width='200px' src='/rcfbbook1200.png' />
                </b-col>
            </b-row>
            <b-row v-if='!profile'>
                <b-col>
                    <b-row class='justify-content-center sign-in-label'>
                        <h3>Sign in to place wagers</h3>
                    </b-row>
                    <b-row class='sign-in-row'>
                        <b-col />
                        <b-col lg='2'>
                            <a class='brand-link text-info' href='/auth/reddit'>
                                <b-row class='justify-content-center'>
                                    <font-awesome-icon class="text-danger" :icon="['fab', 'reddit']"
                                        size='4x'>
                                    </font-awesome-icon>
                                </b-row>
                            </a>
                        </b-col>
                        <b-col />
                    </b-row>
                </b-col>
            </b-row>
            <b-row v-if='profile'>
                <b-col md='6' class='justify-content-center'>
                    <b-row>
                        <b-col>
                            <img width='200px' src='/rcfbbook1200.png' />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h1>/r/CFB Book</h1>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg='4' md='6' class='justify-content-center my-auto'>
                    <h3>Welcome, {{ profile.name }}!</h3>
                    <div>Available funds: <span><currency-symbol class='rcfbucks'></currency-symbol>{{profile.availableFunds}}</span></div>
                    <div>Season winnings: <span :class="winningsClassSeason"><currency-symbol class='rcfbucks'></currency-symbol>{{profile.seasonWinnings}}</span></div>
                    <div>Career winnings: <span :class="winningsClassCareer"><currency-symbol class='rcfbucks'></currency-symbol>{{profile.careerWinnings}}</span></div>
                    <div class='mt-2'>
                        <b-form-checkbox v-model="remindersEnabled" class='justify-contents-center' @change='toggleReminders' switch>
                            Toggle weekly reminders
                        </b-form-checkbox>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-row v-if='profile'>
            <b-col>
                <b-card title='Game Filter'>
                    <b-row>
                        <b-col>
                            <b-input placeholder="Start typing a team name to filter games" v-model='searchTerm'>
                            </b-input>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if='profile'>
            <transition name='fade'>
                <div id='side-tab' v-if='!showBar' @click='openSidebar'>
                    Bet Slip
                </div>
            </transition>
            <b-col v-for="game in gamesFiltered" :key="game.id" md='4'>
                <b-card class='line-card'>
                    <b-row :class='pickClass(game.awayTeam, game.id)'
                        @click="addSelection(game, game.awayTeam)">
                        <b-col sm='7' class='text-left my-auto'>
                            <b-img :src="`/logos/${game.awayId}.png`" /> {{ game.awayTeam }}
                        </b-col>
                        <b-col sm='5' class='my-auto'>
                            <span class='text-muted'>{{ game.line * -1 | sportsline }}</span><span>
                                (-110)</span>
                        </b-col>
                    </b-row>
                    <b-row :class='pickClass(game.homeTeam, game.id)'
                        @click="addSelection(game, game.homeTeam)">
                        <b-col sm='7' class='text-left my-auto'>
                            <b-img :src="`/logos/${game.homeId}.png`" /> {{ game.homeTeam }}
                        </b-col>
                        <b-col sm='5' class='my-auto'>
                            <span class='text-muted'>{{ game.line | sportsline }}</span><span>
                                (-110)</span>
                        </b-col>
                    </b-row>
                    <b-row class='justify-content-center mt-1'>
                        <span
                            class='text-muted'>{{ new Date(game.startDate).toLocaleString().replace(':00 ', ' ') }}</span>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-sidebar id="current-selections" v-model='showBar' right shadow>
            <slot name="header">
                <div class='text-center'>
                    <h3>Bet Slip</h3>
                </div>
            </slot>
            <div class='text-center mb-2'>
                <b-form-checkbox v-model="isParlay" class='justify-contents-center' @change='checkSelections' switch>
                    Parlay
                </b-form-checkbox>
            </div>
            <div class='text-center mb-2' v-if='isParlay'>
                <h5>{{ this.selections.length }} of 10 max</h5>
            </div>
            <b-card v-for='s in selections' :key='s.game.id'>
                <b-row>
                    <b-col class='text-left my-auto' sm='6'>
                        {{s.pick}}
                    </b-col>
                    <b-col class='text-center my-auto' sm='6'>
                        {{ s.line | sportsline }}
                    </b-col>
                </b-row>
                <b-row v-if='!isParlay' class='mt-2'>
                    <b-col class='text-left my-auto' sm="6">
                        <label>Risk:</label>
                    </b-col>
                    <b-col class='text-center my-auto' sm="6">
                        <b-form-input min='0' step='1' size='sm' v-model='s.risk'></b-form-input>
                    </b-col>
                </b-row>
                <b-row v-if='!isParlay' class='mt-3'>
                    <b-col class='text-left my-auto'>
                        <span>Potential winnings: </span><span class='text-success'><currency-symbol class='rcfbucks'></currency-symbol>{{ singleGameWinnings(s.risk) }}</span>
                    </b-col>
                </b-row>
                <b-row class='mt-2'>
                    <b-col class='text-center mt-0'>
                        <b-link class='remove-link text-danger' @click="removeSelection(s)">Remove</b-link>
                    </b-col>
                </b-row>
            </b-card>
            <b-row v-if='isParlay' class='mt-2 container'>
                <b-col class='text-left my-auto' sm="6">
                    <label>Risk:</label>
                </b-col>
                <b-col class='text-center my-auto' sm="6">
                    <b-form-input min='0' step='1' :max='profile.availableFunds' v-model='parlayRisk'></b-form-input>
                </b-col>
            </b-row>
            <b-row v-if='isParlay' class='mt-2'>
                <b-col class='text-left my-auto ml-3'>
                    <span>Potential winnings: </span><span class='text-success'><currency-symbol class='rcfbucks'></currency-symbol>{{ parlayWinnings() }}</span>
                </b-col>
            </b-row>
            <b-alert v-model='overCalculated' variant="danger">
                Not enough funds!
            </b-alert>
            <b-alert v-model='isError' variant="danger">
                Something went wrong. Refresh the page and redo selections.
            </b-alert>
            <b-alert v-model='showSuccess' variant="success">
                Picks successfull submitted.
            </b-alert>
            <div class='text-center mt-4' v-if="(selections && selections.length > 0 && (!isParlay || selections.length > 1)) && !isSubmitting">
                <b-button variant="primary" :disabled='overCalculated' @click="submitPicks">
                    Submit Picks
                </b-button>
            </div>
            <b-spinner class='mt-2' v-if='isSubmitting' variant='secondary'></b-spinner>
        </b-sidebar>
    </b-container>
</template>

<script>
    import CurrencySymbol from '../components/CurrencySymbol.vue';
    export default {
        name: 'Home',
        components: {CurrencySymbol},
        props: ['profile'],
        data() {
            return {
                games: [],
                selections: [],
                showBar: false,
                isParlay: false,
                parlayRisk: 0,
                searchTerm: '',
                isError: false,
                isSubmitting: false,
                showSuccess: false,
                remindersEnabled: false
            };
        },
        computed: {
            winningsClassSeason: function () {
                let winnings = parseFloat(this.profile.seasonWinnings);
                if (winnings > 0) {
                    return 'text-success';
                } else if (winnings < 0) {
                    return 'text-danger';
                }

                return '';
            },
            winningsClassCareer: function () {
                let winnings = parseFloat(this.profile.careerWinnings);
                if (winnings > 0) {
                    return 'text-success';
                } else if (winnings < 0) {
                    return 'text-danger';
                }

                return '';
            },
            overCalculated: function () {
                let risk;
                if (!this.isParlay) {
                    risk = this.selections.map(s => parseFloat(s.risk))
                        .filter(s => s)
                        .reduce((a, c) => a + c, 0);
                } else {
                    risk = parseFloat(this.parlayRisk);
                }

                return this.profile && risk > this.profile.availableFunds;
            },
            gamesFiltered: function () {
                return this.games.filter(g => this.showGame(g));
            }
        },
        methods: {
            addSelection(game, pick) {
                this.showSuccess = false;
                let existing = this.selections.find(s => s.game.id == game.id);
                if (existing) {
                    existing.pick = pick;
                } else if (!this.isParlay || this.selections.length < 10) {
                    this.selections.push({
                        game,
                        pickId: game.homeTeam == pick ? game.homeId : game.awayId,
                        pick,
                        line: game.homeTeam == pick ? game.line : -game.line,
                        risk: 0
                    });

                    if (this.selections.length === 1 && !this.showBar) {
                        this.showBar = true;
                    }
                }
            },
            removeSelection(selection) {
                this.selections = this.selections.filter(s => s.game.id != selection.game.id);
            },
            pickClass(pick, gameId) {
                if (this.selections.find(s => s.pick == pick && s.game.id == gameId)) {
                    return 'selected-row mt-1 pt-1 pb-1';
                } else {
                    return 'pick-row mt-1 pt-1 pb-1';
                }
            },
            openSidebar() {
                this.showBar = true;
            },
            singleGameWinnings(risk) {
                let num = parseFloat(risk);
                if (isNaN(num)) {
                    num = 0;
                }

                let reward = (100/110) * num;

                return reward > 0 ? Math.floor(reward * 100) / 100 : 0;
            },
            parlayWinnings() {
                let num = parseFloat(this.parlayRisk);
                let picks = this.selections.length;

                if (num && picks > 0) {
                    let payout = num * Math.pow(1 + (100/110), picks);
                    return Math.round((payout - num) * 100) / 100;
                } else {
                    return 0;
                }
            },
            checkSelections() {
                if (this.isParlay && this.selections.length > 10) {
                    this.selections = [];
                }
            },
            showGame(game) {
                let st = this.searchTerm.toLowerCase();
                return !this.searchTerm || game.homeTeam.toLowerCase().indexOf(st) !== -1 || game.awayTeam.toLowerCase().indexOf(st) !== -1;
            },
            submitPicks() {
                this.showSuccess = false;
                this.isSubmitting = true;
                this.$axios.post('/api/submission', {
                    isParlay: this.isParlay,
                    risk: this.parlayRisk,
                    picks: this.selections
                }).then(result => {
                    this.isError = false;
                    this.showSuccess = true;
                    this.selections = [];
                    this.isParlay = false;
                    this.parlayRisk = 0;

                    this.$emit('submission');
                }).catch(err => {
                    this.isError = true;
                }).finally(() => {
                    this.isSubmitting = false;
                });
            },
            toggleReminders() {
                this.$axios.post('/api/player/reminders', {
                    remindersEnabled: this.remindersEnabled
                });
            }
        },
        mounted() {
            this.$axios.get('/api/games').then((result) => {
                this.games = result.data;
            });

            if (this.profile) {
                this.remindersEnabled = this.profile.remindersEnabled;
            }
        },
        watch: {
            profile: function (newVal, oldVal) {
                if (newVal) {
                    this.remindersEnabled = newVal.remindersEnabled;
                }
            }
        }
    };

</script>

<style lang='scss'>
    .line-card {

        div[class*="col-"],
        .col {
            margin-top: 0;
        }

        .pick-row {
            &:hover {
                background: #aaaaaa;
                cursor: pointer;
            }
        }

        .selected-row {
            background: #41A464;
        }
    }

    .remove-link {
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }

    #side-tab {
        position: fixed;
        top: 45%;
        right: -40px;
        background: white;
        width: 100px;
        height: 50px;
        transform: rotate(270deg);
        padding: 5px;
        border-radius: 7px;
        cursor: pointer;
        box-shadow: -2px -2px 10px black;
        z-index: 1;

        &:hover {
            box-shadow: -2px -2px 15px black;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0
    }

</style>
